import React, { PureComponent } from "react";
import styled from 'styled-components';
import GLOBAL from 'nonnglobal';

/**
 * Styled
 */
const Container = styled.div`
    margin-top: 10px;
    border-radius: 3px;
    overflow: hidden;
`;

/**
 * Main Component
 */
class FBFansPage extends PureComponent {
    componentDidMount (){
        GLOBAL.initFB().then(() => {
            // const elem = document.createElement('div');
            // const blockquote = document.createElement('blockquote');
            // const a = document.createElement('a');
            // const text = document.createTextNode('9199交易久久');
            // elem.setAttribute('class', 'fb-page');
            // elem.setAttribute('data-href', 'https://www.facebook.com/9199fan/');
            // elem.setAttribute('data-width', '242');
            // elem.setAttribute('data-small-header', 'false');
            // elem.setAttribute('data-adapt-container-width', 'true');
            // elem.setAttribute('data-hide-cover', 'false');
            // elem.setAttribute('data-show-facepile', 'true');
            // blockquote.setAttribute('cite', 'https://www.facebook.com/9199fan/');
            // blockquote.setAttribute('class', 'fb-xfbml-parse-ignore');
            // a.setAttribute('href', 'https://www.facebook.com/9199fan/');
            // a.append(text);
            // blockquote.append(a);
            // elem.append(blockquote);

            // document.body.append(elem);
            window.FB.XFBML.parse();
        }).catch(err =>{
            console.log(err);
        });
    }

    render (){
        return (
            <Container>
                <div className="fb-page" data-href="https://www.facebook.com/9199fan/" data-width="242" data-small-header="false" data-adapt-container-width="true" data-hide-cover="false" data-show-facepile="true">
                    <blockquote cite="https://www.facebook.com/9199fan/" className="fb-xfbml-parse-ignore">
                        <a href="https://www.facebook.com/9199fan/">9199交易久久</a>
                    </blockquote>
                </div>
            </Container>
        );
    }
    
}

export default FBFansPage;